import {
  tenantApiRoutes,
  SettingResponse,
  UpdateSettingDto,
  ServiceTypeSettingResponse,
  UpsertServiceTypeSettingDto,
  DashboardResponse,
} from '@repo/contracts/tenant-api';

import { tenantApi } from '@/redux/api/tenant-api';

/**
 * RTK Query API slice for settings endpoints
 */
export const settingsApi = tenantApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    /**
     * GET /settings - Get tenant settings
     */
    getSettings: builder.query<SettingResponse, void>({
      query: () => tenantApiRoutes.settings.get(),
      providesTags: ['Settings'],
    }),

    /**
     * PATCH /settings - Update tenant settings
     */
    updateSettings: builder.mutation<SettingResponse, UpdateSettingDto>({
      query: (body) => ({
        url: tenantApiRoutes.settings.update(),
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Settings'],
    }),

    /**
     * GET /service-type-settings - Get service type settings
     */
    getServiceTypeSettings: builder.query<ServiceTypeSettingResponse[], void>({
      query: () => tenantApiRoutes.serviceTypeSettings.list(),
      providesTags: ['ServiceTypeSettings'],
    }),

    /**
     * POST /service-type-settings - Create or update service type settings
     */
    upsertServiceTypeSetting: builder.mutation<
      ServiceTypeSettingResponse,
      UpsertServiceTypeSettingDto
    >({
      query: (body) => ({
        url: tenantApiRoutes.serviceTypeSettings.upsert(),
        method: 'POST',
        body,
      }),
      invalidatesTags: ['ServiceTypeSettings'],
    }),

    /**
     * GET /analytics/dashboard - Get dashboard analytics
     */
    getDashboard: builder.query<DashboardResponse, void>({
      query: () => tenantApiRoutes.dashboard.get(),
      providesTags: ['Dashboard'],
    }),
  }),
});

// Export hooks for use in components
export const {
  useGetSettingsQuery,
  useUpdateSettingsMutation,
  useGetServiceTypeSettingsQuery,
  useUpsertServiceTypeSettingMutation,
  useGetDashboardQuery,
} = settingsApi;
